const state = {

}

const getters = {
    newCasEnabled(state, getters, rootState) {
        return rootState.auth.rights.includes('cashdesk')
            && rootState.auth.rights.includes('newcas')
            && !!getters.dynamicConfigValue('newcasFmNumber')
    },
    kkmEnabled(state, getters, rootState) {
        return rootState.auth.rights.includes('cashdesk')
            && Number(getters.dynamicConfigValue('kkm_enabled', state.branch)) === 1
            && (!getters.cashdeskSystemSelected || getters.cashdeskSystemSelected === 'kkm')
    },
    aqsiEnabled(state, getters, rootState) {
        if(getters.kkmEnabled) return false
        return rootState.auth.rights.includes('cashdesk')
            && rootState.auth.rights.includes('aqsi')
            && getters.aqsiAccounts.length > 0
    },
    webkassaEnabled(state, getters, rootState) {
        if(getters.kkmEnabled || getters.newCasEnabled || getters.aqsiEnabled) return false
        return rootState.auth.rights.includes('cashdesk')
            && rootState.auth.rights.includes('webkassa')
    },
    cashdeskSystemSelected(state, getters) {
        const forcedSystem = getters.dynamicConfigValue('cashdeskSystem')
        if(forcedSystem) return forcedSystem
        if(getters.kkmEnabled) return 'kkm'
        if(getters.newCasEnabled) return 'newcas'
        if(getters.aqsiEnabled) return 'aqsi'
        if(getters.webkassaEnabled) return 'webkassa'
        return null
    },
    aqsiAccounts(state, getters, rootState) {
        const branchId = rootState.auth.branch || null
        if(!rootState.auth.rights.includes('aqsi')) return []
        if(getters.kkmEnabled) return []
        return getters.dynamicConfigValue('aqsi_key', branchId) || []
    },
}

const mutations = {

}

const actions = {

}

export default {
    state,
    actions,
    mutations,
    getters
}
